module.exports = __webpack_public_path__ + "img/1.de1bf082.png";